module.exports = __webpack_public_path__ + "img/no_data.5fa34f6c.png";